import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=1cb09fb8&"
import script from "./GoBack.vue?vue&type=script&lang=ts&"
export * from "./GoBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports